goog.provide("shadow.js.shim.module$react_use$lib$useKey$default");
shadow.js.shim.module$react_use$lib$useKey$default = shadow.js.shim.module$react_use$lib$useKey.default;
